import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';

import React from 'react';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';
import { VoucherFormSchemaValues } from 'src/features/vouchers/utils/formSchema';
import { useListVoucherTypes } from 'src/features/voucherTypes/api/useListVoucherTypes';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import { useListCustomers } from 'src/features/customers/api/useListCustomers';
import SearchSelectFormField from 'src/registry/components/forms/SearchSelectFormField';
import { customersMessages } from 'src/features/customers/utils/messages';
import { useParams } from 'react-router-dom';

type VoucherFormProps = {
    form: UseFormReturn<VoucherFormSchemaValues>;
    onSubmit: (values: VoucherFormSchemaValues) => void;
    isEdit?: boolean;
};

function VoucherTypeForm({ onSubmit, form, isEdit = false }: VoucherFormProps) {
    const { formatMessage } = useIntl();
    const [searchCustomer, setSearchCustomer] = React.useState<string>('');
    const { customerId } = useParams();

    const disableCustomerSelect = Boolean(customerId);

    const { data: voucherTypes } = useListVoucherTypes({
        is_active: true,
        has_reached_limit: false,
    });
    const { data: customers } = useListCustomers({
        search: searchCustomer,
    });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormField
                control={form.control}
                name="voucher_type"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...voucherTypesMessages.voucherType} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} value={field.value ?? ''} disabled={isEdit}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue
                                            placeholder={`${formatMessage(voucherTypesMessages.voucherType)}...`}
                                        />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {voucherTypes?.results.map((option) => (
                                            <SelectItem key={option.id} value={option.id}>
                                                {option.name}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <SearchSelectFormField
                name="customer"
                control={form.control}
                label={formatMessage(customersMessages.customer)}
                items={customers?.results ?? []}
                clearable
                required={false}
                placeholder={`${formatMessage(customersMessages.customer)}...`}
                searchPlaceholder={formatMessage(customersMessages.searchCustomer)}
                emptyTitle={formatMessage(customersMessages.noCustomer)}
                emptyDescription={formatMessage(customersMessages.noCustomerFound)}
                getItemValue={(customer) => customer.id}
                getItemLabel={(customer) => customer.name}
                getItemKeywords={(customer) => [customer.name]}
                loadOptions={setSearchCustomer}
                disabled={disableCustomerSelect}
            />
        </Form>
    );
}

export default VoucherTypeForm;
